import { render, staticRenderFns } from "./CommLogPage.vue?vue&type=template&id=6e529f91&scoped=true&"
import script from "./CommLogPage.vue?vue&type=script&lang=js&"
export * from "./CommLogPage.vue?vue&type=script&lang=js&"
import style0 from "./CommLogPage.vue?vue&type=style&index=0&id=6e529f91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e529f91",
  null
  
)

export default component.exports